import { useEffect, useState } from 'react';

const CACHE = {};

export function useAudioDuration(src) {
	const [duration, setDuration] = useState(CACHE[src] || null);

	useEffect(() => {
		if (!src || CACHE[src] || duration) return;

		const audio = new Audio(src);
		audio.addEventListener('loadedmetadata', () => {
			const secs = Math.floor(audio.duration);
			CACHE[src] = secs;
			setDuration(secs);
		});
	}, [src, duration]);

	return duration;
}
